import request from '@/services/interceptor.js'

export const get_aperture = (filtri) => {
    return request({ url: '/aperture', method: 'get', params: filtri || {}, loadingBar: true })
}

export const create_apertura = (par) => {
    return request({ url: '/aperture', method: 'post', data: par, loadingBar: true })
}

export const update_apertura = (id, par) => {
    return request({ url: `/aperture/${id}`, method: 'put', data: par, loadingBar: true })
}

export const delete_apertura = (id) => {
    return request({ url: `/aperture/${id}`, method: 'delete', loadingBar: true })
}
